






import Vue from "vue"
import { Component } from "vue-property-decorator"

@Component
export default class MobileIconComponent extends Vue {
    iconActive: boolean = false

    setIconActive() {
        this.iconActive = !this.iconActive
        this.$emit('showSidebar')
    }
}
